import React from 'react';
import { InsightsEmptyState } from '@/experiences/sales-portal/domain/insights/components/insights-empty-state';

/**
 * Empty state for the active alerts feed. Thin wrapper around the shared
 * Insights empty state so the feed and the tab shell stay visually consistent.
 */
export const AlertFeedEmpty: React.FC = () => <InsightsEmptyState />;
